// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bad8416dfe0f9aff1ee3","655":"41e6f53d175dbd34a2b6"}[chunkId] + ".js";
};